import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createPortal } from "react-dom";
import classNames from "classnames";
import { Button } from "../../../../components/Button";
import { useTranslations } from "../../../../providers/useTranslations";
import { LanguageSelectorList } from "./components/LanguageSelectorList";
import styles from "./LanguageSelectorPopupMobileFullscreen.module.scss";
export const LanguageSelectorPopupMobileFullscreen = ({ languages, onClose, onApplyLanguage, isOpened, popupContext, }) => {
    const { __ } = useTranslations();
    const currentPageLanguage = languages.find(({ current }) => current);
    const handleSelectLanguage = (selectedLanguage) => {
        onApplyLanguage(selectedLanguage);
        onClose();
    };
    if (!isOpened) {
        return null;
    }
    return createPortal(_jsx("div", { "data-testid": "languageSelectorPopupMobileFullscreen", className: classNames("languageSelectorPopupMobileFullscreen", styles.modal, {
            "light-theme": popupContext === "AGE_CONFIRMATION",
        }), children: _jsx("div", { className: styles.container, children: _jsxs("div", { className: styles.content, children: [_jsx("h3", { className: styles.title, children: __("languageselector.select_language.headline") }), _jsx(LanguageSelectorList, { languages: languages, selectedLanguage: currentPageLanguage, onSelectLanguage: handleSelectLanguage }), _jsx(Button, { onClick: onClose, color: "secondary", size: "small", className: styles.button, "data-testid": "languageSelectorCancelBtn", children: __("languageselector.cancel.btn") })] }) }) }), document.body);
};
//# sourceMappingURL=LanguageSelectorPopupMobileFullscreen.js.map